import { MutableRefObject, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import type { AxiosInstance } from 'axios';

import { useKeycloak } from '@react-keycloak/web';

export const useAxios = (
  baseURL = `${process.env.REACT_APP_PRONTUARIO_API}`,
): MutableRefObject<AxiosInstance | undefined> => {
  const axiosInstance = useRef<AxiosInstance>();
  const { keycloak, initialized } = useKeycloak();
  const token = keycloak?.token ?? '';

  useEffect(() => {
    axiosInstance.current = axios.create({
      baseURL,
      headers: {
        Authorization: initialized ? `Bearer ${token}` : undefined,
      },
    });

    return () => {
      axiosInstance.current = undefined;
    };
  }, [baseURL, initialized, token]);

  return axiosInstance;
};

export const useHasRealmRole = (role: string): boolean => {
  const { keycloak, initialized } = useKeycloak();

  const hasRole = useMemo(() => {
    if (!initialized || !keycloak.authenticated) {
      return false;
    }

    return keycloak.hasRealmRole(role);
  }, [initialized, keycloak, role]);

  return hasRole;
};
